import type {
  CreateCrosspostRequest,
  CreateFacebookPostRequest,
  CreateInstagramPostRequest,
} from '@pulsify/shared/dto'
import { useMutation } from '@tanstack/react-query'
import { crosspostingApi } from '~/entities/crossposting/api/crossposting-api'

export function useCreateFacebookPost(businessId: string, listingId: string) {
  return useMutation({
    mutationFn: (args: { payload: CreateFacebookPostRequest; files: File[] }) =>
      crosspostingApi.createFacebookPost(businessId, listingId, args.payload, args.files),
  })
}

export function useCreateInstagramPost(businessId: string, listingId: string) {
  return useMutation({
    mutationFn: (args: { payload: CreateInstagramPostRequest; files: File[] }) =>
      crosspostingApi.createInstagramPost(businessId, listingId, args.payload, args.files),
  })
}

export function useCreateCrosspost(businessId: string, listingId: string) {
  return useMutation({
    mutationFn: (args: { payload: CreateCrosspostRequest; files: File[] }) =>
      crosspostingApi.createCrosspost(businessId, listingId, args.payload, args.files),
  })
}
